import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import progressGif from "../../images/progress.gif";
import Non_Avail_Cards_Excel from "./Non_Avail_Cards_Excel";

const Non_Avail_Cards_Report = () => {
  const [startMonth, setStartMonth] = useState("");
  const [startYear, setStartYear] = useState("");
  const [endMonth, setEndMonth] = useState("");
  const [endYear, setEndYear] = useState("");
  const [yearList, setYearList] = useState([]);
  const [startMonths, setStartMonths] = useState([]);
  const [endMonths, setEndMonths] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showGif, setShowGif] = useState(false);
  const [showDistrictDropdown, setShowDistrictDropdown] = useState(false);

  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const fetchYearRange = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/api/nonAvailCards/yearRange`);
        const { minyear, maxYear } = res.data;
        const list = [];
        for (let y = maxYear; y >= minyear; y--) list.push(y);
        setYearList(list);
      } catch (err) {
        console.error("Error fetching year range:", err);
      }
    };
    fetchYearRange();
  }, []);

  useEffect(() => {
    if (!startYear) return;

    const fetchStartMonths = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/api/nonAvailCards/months`, {
          params: { year: startYear },
        });
        setStartMonths(res.data.map((m) => m.month));
      } catch (err) {
        console.error("Error fetching start year months:", err);
      }
    };

    fetchStartMonths();
  }, [startYear]);

  useEffect(() => {
    if (!endYear) return;

    if (endYear === startYear) {
      setEndMonths([...startMonths]);
      return;
    }

    const fetchEndMonths = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/api/nonAvailCards/months`, {
          params: { year: endYear },
        });
        setEndMonths(res.data.map((m) => m.month));
      } catch (err) {
        console.error("Error fetching end year months:", err);
      }
    };

    fetchEndMonths();
  }, [endYear, startYear]);

  const handleGenerateReport = async () => {
    if (!startYear || !startMonth || !endYear || !endMonth) {
      alert("Please select both month and year ranges.");
      return;
    }

    const sYear = parseInt(startYear);
    const eYear = parseInt(endYear);
    const sMonth = parseInt(startMonth);
    const eMonth = parseInt(endMonth);

    if (eYear < sYear || (eYear === sYear && eMonth < sMonth)) {
      alert("End date must be greater than Start date.");
      return;
    }

    try {
      setLoading(true);
      setShowGif(true);
      setShowDistrictDropdown(false);
      setMessage("");

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/nonAvailCards/starEndMonthYear`,
        null,
        { params: { startMonth, startYear, endMonth, endYear },withCredentials: true, }
      );

      setTimeout(() => {
        setShowGif(false);
        setLoading(false);
        setMessage(response.data.message || "Report generated successfully.");
        setShowDistrictDropdown(true);
      }, 2000);
    } catch (error) {
      console.error("Error generating report:", error);
      setTimeout(() => {
        setShowGif(false);
        setLoading(false);
        setMessage("Error occurred while generating the report.");
      }, 2000);
    }
  };

  return (
    <div
      style={{
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          textAlign: "center",
          width: "59%",
          minWidth: "520px",
          maxWidth: "700px",
          borderRadius: "8px",
        }}
      >
        <table
          style={{
            width: "97%",
            borderCollapse: "collapse",
            tableLayout: "fixed",
            margin: "0 auto",
          }}
        >
          <tbody>
            <tr>
              <td style={cellStyle}>
                <span style={inlineLabel}>Start Year:</span>
                <select
                  value={startYear}
                  onChange={(e) => setStartYear(e.target.value)}
                  style={selectStyle}
                >
                  <option value="">--Select--</option>
                  {yearList.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </td>

              <td style={cellStyle}>
                <span style={inlineLabel}>Start Month:</span>
                <select
                  value={startMonth}
                  onChange={(e) => setStartMonth(e.target.value)}
                  style={selectStyle}
                  disabled={!startMonths.length}
                >
                  <option value="">--Select--</option>
                  {startMonths.map((m) => (
                    <option key={m} value={m}>
                      {getMonthName(m)}
                    </option>
                  ))}
                </select>
              </td>

              <td style={cellStyle}>
                <span style={inlineLabel}>End Year:</span>
                <select
                  value={endYear}
                  onChange={(e) => setEndYear(e.target.value)}
                  style={selectStyle}
                >
                  <option value="">--Select--</option>
                  {yearList.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </td>

              <td style={cellStyle}>
                <span style={inlineLabel}>End Month:</span>
                <select
                  value={endMonth}
                  onChange={(e) => setEndMonth(e.target.value)}
                  style={selectStyle}
                  disabled={!endMonths.length}
                >
                  <option value="">--Select--</option>
                  {endMonths.map((m) => (
                    <option key={m} value={m}>
                      {getMonthName(m)}
                    </option>
                  ))}
                </select>
              </td>
            </tr>

            <tr>
              <td colSpan="4" style={{ textAlign: "center", paddingTop: "5px", paddingBottom: "5px" }}>
                <button
                  onClick={handleGenerateReport}
                  disabled={loading}
                  style={{
                    padding: "6px 22px",
                    backgroundColor: "#222",
                    color: "white",
                    border: "none",
                    borderRadius: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Submit
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        {showGif && (
          <div style={{ marginTop: "20px" }}>
            <img src={progressGif} alt="Loading..." width="220" height="12" />
          </div>
        )}

        {message && !showGif && (
          <p
            style={{
              marginTop: "15px",
              color: "darkred",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
          >
        
          </p>
        )}

        {showDistrictDropdown && (
          <div style={{ marginTop: "15px" }}>
            <Non_Avail_Cards_Excel
              startMonth={startMonth}
              startYear={startYear}
              endMonth={endMonth}
              endYear={endYear}
            />
          </div>
        )}
      </div>
    </div>
  );
};

function getMonthName(num) {
  const names = [
    "",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return names[num];
}

const cellStyle = {
  border: "1px solid #ddd",
  padding: "4px 6px",
  textAlign: "center",
  whiteSpace: "nowrap",
  width: "18%",
  fontSize: "12px",
};

const inlineLabel = {
  fontWeight: "600",
  marginRight: "4px",
  fontSize: "12px",
};

const selectStyle = {
  width: "50%",
  padding: "3px 4px",
  borderRadius: "3px",
  border: "1px solid #bbb",
  fontSize: "12px",
};

export default Non_Avail_Cards_Report;
